import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Icon } from '@/icons';
import { SECTIONS, SECTION_ICONS } from '../meta';

const Aside = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
`;

const BrandName = styled.div`
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.color.textPrimary};
  line-height: 1.1;
`;

const NavLink = styled(Link)<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  text-decoration: none;
  color: ${({ theme, $active }) => ($active ? theme.color.textPrimary : theme.color.textMuted)};
  background: ${({ theme, $active }) => ($active ? theme.color.glassBg : 'transparent')};
  font-size: ${({ theme }) => theme.fontSize.sm};
  &:hover {
    background: ${({ theme }) => theme.color.glassBg};
    color: ${({ theme }) => theme.color.textPrimary};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: -2px;
  }
`;

const Label = styled.span`
  flex: 1;
`;

const Soon = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: 0 6px;
`;

export function CouncilSidebar({ activeId }: { activeId: string }) {
  return (
    <Aside aria-label="Council sections">
      <Brand>
        <Icon name="shield" size={22} />
        <BrandName>
          Council of
          <br />
          Moderation
        </BrandName>
      </Brand>
      {SECTIONS.map((s) => (
        <NavLink
          key={s.id}
          to={`/council/${s.id}`}
          replace
          $active={s.id === activeId}
          aria-current={s.id === activeId ? 'page' : undefined}
        >
          <Icon name={SECTION_ICONS[s.id]} size={18} />
          <Label>{s.label}</Label>
          {!s.built && <Soon>soon</Soon>}
        </NavLink>
      ))}
      {/* No stats band here. This sidebar used to carry four hardcoded figures —
          "Reports filed 1,842", "AI-cleared 1,231", "Escalated to humans 611" and
          "Active teams 12" — on every Council screen, beside an Overview panel
          reading the real numbers off the API. Two of them contradicted it outright,
          and "AI-cleared" described a system that does not exist. The live figures
          belong on Overview, which reads them from useCouncilOverview(); duplicating
          them here is what let them drift apart in the first place. */}
    </Aside>
  );
}
